import * as React from "react"
import {Typography} from '@mui/material'
import {formatPercentage} from "@ui-seeker/utils"

import {NotAllowedBlock} from "@components";


export default function priceDiffColumn() {
    return {
        name: 'priceDiff',
        label: 'Price Diff (%)',
        options: {
            filter: false,
            customBodyRowRenderLite: (value) => <Typography sx={{ fontSize: '0.875rem', textAlign: 'center' }}>
                { value !== null ? formatPercentage(value, {decimals: 2}) : <NotAllowedBlock /> }
            </Typography>
        }
    }
}